var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Home")]),_vm._v(" 29/09/2021-0811 "),_c('app-speed-dial',{attrs:{"large":""}},[_c('app-btn',{attrs:{"small":"","fab":""}},[_c('app-icon',{attrs:{"icon":"account"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }